import { v4 } from 'uuid'
import { baseLogin } from '@/api/login'
import { setBaseToken } from '@/axios/cookies'

let baseTokenPromise = null

export function getUUid() {
  return v4()
}


export const getBaseToken = () => {
  if (baseTokenPromise) return baseTokenPromise

  console.log('基础登录')
  const loginParam = {
    username: getUUid(),
    password: getUUid()
  }

  baseTokenPromise = baseLogin(loginParam).then(res => {
    console.log('基础登录响应', res)
    if (res.status !== 200 || !res.data || !res.data.token) {
      throw new Error((res && res.msg) || '基础登录失败')
    }
    setBaseToken(res.data.token, res.data.expires_time)
    return res
  })

  baseTokenPromise = baseTokenPromise.then(
    res => {
      baseTokenPromise = null
      return res
    },
    error => {
      baseTokenPromise = null
      throw error
    }
  )
  return baseTokenPromise
}

export function parseTimeY(time, cFormat) {
    if (arguments.length === 0) {
        return null
    }
    const format = cFormat || '{y}.{m}.{d}'
    let date
    if (typeof time === 'undefined' || time === null || time === 'null') {
        return ''
    } else if (typeof time === 'object') {
        date = time
    } else {
        if ((typeof time === 'string') && (/^[0-9]+$/.test(time))) {
            time = parseInt(time)
        }
        if ((typeof time === 'number') && (time.toString().length === 10)) {
            time = time * 1000
        }
        date = new Date(time)
    }
    const formatObj = {
        y: date.getFullYear(),
        m: date.getMonth() + 1,
        d: date.getDate()
    }
    const time_str = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
        let value = formatObj[key]
        // Note: getDay() returns 0 on Sunday
        if (key === 'a') { return ['日', '一', '二', '三', '四', '五', '六'][value ] }
        if (result.length > 0 && value < 10) {
            value = '0' + value
        }
        return value || 0
    })
    return time_str
}

export function parseTimeX(time, cFormat) {
    console.log(time)
    let time_str = time.replaceAll('T',' ')
    time_str = time_str.substring(0,19)
    time_str = time_str.replaceAll('-','.')
    return time_str
}
